<div class="ag-cell-label-container grid-header" role="presentation" (click)="onHeaderClick($event)"
    (contextmenu)="onHeaderContextMenu($event)" [attr.data-automation-id]="automationId"
    [title]="colDef ? colDef.headerName : ''">
    <div class="sort-icon"
        *ngIf="colDef && gridContext && ((colDef.sortBy && colDef.sortBy === gridContext.sortBy) || (colDef.defaultSortBy && colDef.defaultSortBy === gridContext.sortBy))"
        [attr.data-automation-id]="automationId + '-sort-icon'"
        [ngClass]="[colDef.defaultSortBy ? 'default-arrow' : '']">
        <i class="fa"
            [ngClass]="[gridContext.sortAscending ? 'fa-caret-up' : 'fa-caret-down', colDef.defaultSortBy ? 'default-arrow' : '']"></i>
    </div>
    <div class="hover-sort-icon" *ngIf="colDef && gridContext && colDef.sortBy"
        [attr.data-automation-id]="automationId + '-hover-sort-icon'">
        <i class="fa"
            [ngClass]="[colDef && gridContext && colDef.sortBy && colDef.sortBy === gridContext.sortBy && gridContext.sortAscending ? 'fa-caret-down' : 'fa-caret-up']"></i>
    </div>
    <div ref="eLabel" class="ag-header-cell-label" role="presentation"
        [ngClass]="[colDef && colDef.sortBy && gridContext && gridContext.sortEnabled ? 'sortable' : '']">
        <span ref="eText" class="ag-header-cell-text" role="columnheader"
            [ngClass]="[colDef && colDef.headerAlignDirection ? 'align-' + colDef.headerAlignDirection : '', colDef && colDef.headerClass ? colDef.headerClass : '']"
            [attr.data-automation-id]="automationId + '-label'" requiredAsterisk
            [isRequired]="colDef && colDef.headerRequired">
            {{ params ? params.displayName : '' }}
        </span>
    </div>
</div>

<div class="grid-header grid-header-inline-filter" *ngIf="gridContext.inlineGridFilter" role="presentation"
    [attr.data-automation-id]="automationId + 'grid-header-filter'">
    <div ref="eLabel" class="ag-header-cell-label grid-filter" role="presentation">
        <span ref="eText" class="ag-header-cell-text filter-column-header" role="columnheader"
            [attr.data-automation-id]="automationId + '-label'">
            <div class="filter-widget" (focusout)="onBlur()" tabindex="1"
                [hidden]="ownerSingleChoiceFilter || singleChoiceFilter || comboBoxFilter || showIconButtonsFilter">

                <input type="text" [readonly]="colDef.filterType !== 'freeform'"
                    [attr.data-automation-id]="automationId + '-filter-input'" name="" class="freeform-filter"
                    [class.date-input]="colDef.filterType === 'date'" [(ngModel)]="filterValue"
                    [class.filter-active]="filterValue.trim()" (input)="onFilterApply($event)"
                    [class.date-focus]="colDef.filterType === 'date' && isOpen" id="freeform-filter-{{colDef.colId}}"
                    [class.date-focus-out]="colDef.filterType === 'date' && isOpen && !filterValue.trim()"
                    (click)="onFilter($event)" (keydown.enter)="onFilterApply($event)" (focus)="onFocus($event)"
                    placeholder="{{colDef.filterPlaceholder}}" [disabled]="!colDef.filterType"
                    title="{{colDef.filterType === 'date' ? (!filterValue.trim() ? 'Click to select the date/time range' : filterValue.trim()) : ''}}">
                <i class="fa" [hidden]="(filterValue.trim() || colDef.filterType === 'freeform' || !colDef.filterType)"
                    [ngClass]="[gridContext ? 'fa-caret-down' : '']" (click)="onFilter()"></i>
                <button [class.filter-visible]="filterValue.trim()" [class.filter-clear]="!filterValue.trim()"
                    (click)="onFunnelOrClearClick()" [hidden]="!colDef.filterType"
                    [attr.data-automation-id]="automationId + '-clear-button'">
                    <i class="fa" [class.fa-filter]="!filterValue.trim()" [class.fa-times]="filterValue.trim()"></i>
                </button>

                <div class="dropdown dropdown-date" dropdown *ngIf="colDef.filterType === 'date'">
                    <div class="picker-container" [hidden]="!isOpen" id="dateTimePickerContainer{{colDef.field}}"
                        data-automation-id="date-time-picker-container">
                        <res-custom-date-time-range-picker class="date-time-picker" name="timePicker"
                            [onPickerApplyClick]="onDatePickerApply" [onPickerCancelClick]="onDatePickerCancel"
                            [automationId]="automationId + '-filter'" [(filterItem)]="filterValue">
                        </res-custom-date-time-range-picker>
                    </div>
                </div>

                <div class="filter-widget-box" [hidden]="!multiChoiceFilter">
                    <input type="text" class="multi-choice-input" placeholder="Filter ..."
                        [(ngModel)]="multiChoiceFilterData.filterValue"
                        (input)="filterItem(multiChoiceFilterData.filterValue)" />
                    <button class="filter-widget-remove-filter-btn"
                        [class.filter-visible]="multiChoiceFilterData.filterValue.trim()"
                        [class.filter-clear]="!multiChoiceFilterData.filterValue.trim()"
                        (click)="clearMultiChiceFilterData()" [hidden]="!colDef.filterType">
                        <i class="fa" [class.fa-filter]="!multiChoiceFilterData.filterValue.trim()"
                            [class.fa-times]="multiChoiceFilterData.filterValue.trim()"></i>
                    </button>
                    <res-custom-checkbox id="selectAllCheckbox"
                        [attr.data-automation-id]="automationId + 'multichoice-filter-select-all-checkbox'"
                        [(ngModel)]="multiChoiceFilterData.selectAll"
                        (ngModelChange)="selectAllItems(multiChoiceFilterData.selectAll)" [content]="'Select All'">
                    </res-custom-checkbox>
                    <div class="multi-choice-selection-box">
                        <res-custom-checkbox *ngFor="let item of filteredItems"
                            [attr.data-automation-id]="automationId + 'multichoice-filter-items' + item.name"
                            [(ngModel)]="item.selected" [content]="item.name"></res-custom-checkbox>
                    </div>
                    <div class="filter-widget-box-footer">
                        <button type="button"
                            [attr.data-automation-id]="automationId + 'multichoice-filter-apply-button'"
                            class="primary-button" (click)="onFilterApply()"><i class="fa fa-check"></i>Apply</button>
                        <button type="button"
                            [attr.data-automation-id]="automationId + 'multichoice-filter-cancel-button'"
                            class="secondary-button" (click)="onFilterCancel()">Cancel</button>
                    </div>
                </div>

                <div class="filter-widget-box" [hidden]="!rangeFilter">
                    <input type="text" class="range-input" placeholder="From ..." [(ngModel)]="rangeFilterData.start" />
                    <label> ~~ </label>
                    <input type="text" class="range-input" placeholder="To ..." [(ngModel)]="rangeFilterData.end" />
                    <div class="filter-widget-box-footer">
                        <button type="button" [attr.data-automation-id]="automationId + 'range-filter-apply-button'"
                            class="primary-button" (click)="onFilterApply()"><i class="fa fa-check"></i>Apply</button>
                        <button type="button" [attr.data-automation-id]="automationId + 'range-filter-cancel-button'"
                            class="secondary-button" (click)="onFilterCancel()">Cancel</button>
                    </div>
                </div>

            </div>
            <div tabindex="1" [hidden]="!ownerSingleChoiceFilter">
                <select class="filter-owner-single-choice" [(ngModel)]="ownerSingleChoiceSelected"
                    (focus)="onFocus($event)" (change)="onFilterApply()"
                    [attr.data-automation-id]="automationId + '-option'">
                    <option *ngFor="let option of ownerSingleChoiceFilterData" [ngValue]="option">{{option}}</option>
                </select>
            </div>
            <div tabindex="1" [hidden]="!singleChoiceFilter">
                <select class="filter-owner-single-choice" (focus)="onFocus($event)"
                    [ngClass]="[singleChoiceSelected && singleChoiceSelected !== ' ' && singleChoiceSelected !== 'All' ? 'yellow-background' : '']"
                    [(ngModel)]="singleChoiceSelected" (change)="onFilterApply()"
                    [attr.data-automation-id]="automationId + '-option'">
                    <option *ngFor="let option of singleChoiceFilterData" [ngValue]="option">{{option}}</option>
                </select>
            </div>
            <div [hidden]="!showIconButtonsFilter" class="icon-buttons-filter-class">
                <button type="button" [attr.data-automation-id]="automationId + 'icon-button'" [ngClass]="[isSingleIconSelection ? 'hasSingleIcon' : 'hasMultipleIcons', activeIconButtonSelection ? 'btn-active-class' : '']"
                        class="secondary-button icon-button" (click)="onIconClickSelection($event)" [title]="iconSelectionTitle"><i *ngIf="!isSingleIconSelection" class="fa fa-exclamation-triangle"> </i> <span *ngIf="!isSingleIconSelection"> / </span> <i class="fa fa-exclamation-circle"></i></button>
            </div>
            <div tabindex="1" [hidden]="!comboBoxFilter">
                <res-custom-combo-box class="filter-custom-combo" [(selectedItem)]="filterValue" [fillWidth]="true"
                    [isFilterComboBox]="true" [items]="comboBoxFilterData" [allItems]="comboBoxFilterData"
                    placeholder="" (focusin)="onFocus()" [automationId]="automationId + '-filter-combo-box'"
                    [onSelectionChanged]="onSelectionComboBoxChanged">
                </res-custom-combo-box>
                <button [hidden]="!filterValue" (click)="clearFilter()" class="filter-clear-combo"
                    [attr.data-automation-id]="automationId + '-clear-button'">
                    <i class="fa fa-times"></i>
                </button>
            </div>
        </span>
    </div>
</div>